import AuditLogsOld from './AuditLogsOld';

export default AuditLogsOld;
